import FloorplanZoomControls from './floorplan-zoom-controls';

export default FloorplanZoomControls;
